<template>
  <section id="dashboard">
    <b-row class="match-height">
      <b-col
        lg="12"
        sm="12"
      >
        <payment-detail />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import PaymentDetail from './PaymentDetail.vue'

export default {
  components: {
    BRow,
    BCol,
    PaymentDetail
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-payment.scss';
</style>
